import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import classNames from 'classnames';
import styles from './RadioButtons.module.scss';
import { IRadioButtons } from './RadioButtons.types';

export const RadioButtons: React.FC<IRadioButtons> = (props) => {
  const { name, options, selectedOption, direction, onChange, type = 'primary', className = '', disabled } = props;

  return (
    <div
      data-testid="radio-buttons-container"
      className={classNames(
        styles['ds-radio-buttons-container'],
        direction === 'column' ? styles['flex-column'] : '',
        styles[type],
        className
      )}
    >
      {options.map((option, index) => {
        const id = `option_${index}`;
        return (
          <div key={index} className={classNames(styles['radio-button-item'], { disabled })}>
            <RadioButton
              name={name}
              inputId={id}
              value={option.value}
              checked={selectedOption === option.value}
              disabled={disabled}
              onChange={(e) => onChange(e.value as string | number | boolean)}
            />
            <label htmlFor={id}>{option.label}</label>
          </div>
        );
      })}
    </div>
  );
};
